// extracted by mini-css-extract-plugin
export default {"search-results-wrapper":"SearchResults_search-results-wrapper__K0RYU"};